import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@mui/styles';
import { useMediaQuery, Grid2 as Grid, Typography, Button, Box } from '@mui/material';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';

const useStyles = makeStyles(() => ({
  image: {
    maxWidth: 420,
    borderRadius: '24px',
  },
}));

const StepCard = ({ title, description }) => {
  return (
    <Box
      width="100%" height="100%"
      flex={1}
      display="flex"
      flexDirection="column"
      border={1}
      borderRadius={2}
      borderColor="primary.main"
      p={2} >
      <Typography
        variant={'h5'}
        gutterBottom
        sx={{ fontWeight: 700 }}
      >
        {title}
      </Typography>
      <Typography color="text.secondary">{description}</Typography>

    </Box>
  );
};

const TrustedPartner = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <Grid
        container
        justify="space-between"
        spacing={isMd ? 4 : 2}
        direction={isMd ? 'row' : 'column'}
      >
        <SectionHeader
          title="The ONDC Advantage: Transform Your Business"
          subtitle=" "
          align="left"
          disableGutter
          subtitleProps={{
            color: 'textPrimary',
            variant: 'body1',
          }}
        />

        <Grid
          item
          container
          alignItems="center"
          justify="flex-start"
          size={{ xs: 12, md: 8 }}
          data-aos={'fade-up'}
        >
          <Grid container spacing={isMd ? 4 : 2}>
            <Grid size={{ xs: 12, md: 6 }} >
              <StepCard
                title="Expanded Market Reach"
                description="Gain instant visibility across multiple buyer apps like Paytm, Meesho, and Magicpin - reaching millions of new customers without additional marketing costs." />

            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <StepCard
                title="Reduced Dependency on Single Platforms"
                description="Diversify your online presence and reduce risk by selling through multiple channels with a single integration, protecting against algorithm changes." />

            </Grid>
          </Grid>
          <Grid size={{ xs: 12, md: 12 }}>
            <StepCard
              title="Lower Commission Costs"
              description="ONDC's transparent fee structure typically results in significantly lower commissions compared to traditional marketplaces, improving your profit margins." />

          </Grid>

        </Grid>
        <Grid
          item
          container
          justify={isMd ? 'flex-end' : 'flex-start'}
          alignItems="center"
          size={{ xs: 12, md: 4 }}
          data-aos={'fade-up'}
        >
          <Image
            src="/assets/ondc/transform_business.png"
            alt="ONDC Transform Busienss with Mperito"
            className={classes.image}
          />
        </Grid>
      </Grid>
    </div>
  );
};

TrustedPartner.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default TrustedPartner;
